import { Action } from '../models/chatbot/types';
import { Actionable } from '../models/assistant/interfaces/Actionable';
import { ActionNavigationType } from '../models/assistant/interfaces/Navigation';
import { convertLegacyAssistantUrl } from './url-utils';

/**
 * Converts a backend Action to frontend Actionable format
 * @param action - The action from the backend card
 * @param heading - The card heading to use as navigation title
 * @returns Actionable format expected by AssistantAction component
 */
export const convertToActionable = (
  action: Action,
  heading: string
): Actionable => {
  if (action.type === 'navigation') {
    let processedUrl = action.navigation.url;

    // Check if this is a legacy SC4 URL with an assistant route in the hash
    if (action.navigation.type === 'deeplink') {
      const result = convertLegacyAssistantUrl(action.navigation.url);
      if (result) {
        processedUrl = result;
      }
    }

    return {
      type: 'navigation',
      navigation: {
        url: processedUrl,
        title: heading,
        type: action.navigation.type as ActionNavigationType,
        relative_url:
          action.navigation.relative_url?.web ||
          action.navigation.relative_url?.mobile
            ? {
                web: action.navigation.relative_url.web || '',
                mobile: action.navigation.relative_url.mobile || '',
              }
            : undefined,
      },
      request: {} as any, // Required by Actionable interface
    };
  } else {
    return {
      type: 'request',
      navigation: {} as any, // Required by Actionable interface
      request: {
        endpoint: action.request.endpoint,
        method: action.request.method as any,
        payload_string: action.request.payload_string,
      } as any,
    };
  }
};
